import axios from 'axios'

import { handleRequestError } from '@/actions/request'
import { SUPPORT_EMAIL } from '@/constants'

import { USER_AGREEMENT } from '../action-types'

export const requestUserAgreementDraft =
    ({ userAgreementType }) =>
    (dispatch, getState) => {
        const { profile } = getState()
        const { id: userId, accountantId } = profile

        dispatch({ type: USER_AGREEMENT.REQUEST_DRAFT })
        return axios
            .get(`/users/${userId}/useragreements/draft?accountantId=${accountantId}&type=${userAgreementType}`)
            .then((response) => {
                const { data } = response
                dispatch({ type: USER_AGREEMENT.RECEIVE_DRAFT, data })
                return data
            })
            .catch((error) => {
                dispatch(
                    handleRequestError(error, {
                        customMessage: `Ha habido un error al solicitar el acuerdo con tu asesor. Por favor, contacta con ${SUPPORT_EMAIL} y lo solucionaremos`,
                    })
                )
                dispatch({ type: USER_AGREEMENT.ERROR_DRAFT })
                return Promise.reject(error)
            })
    }

export const requestUserAgreement = (agreementType) => (dispatch, getState) => {
    const { profile } = getState()
    const { id: userId } = profile

    dispatch({ type: USER_AGREEMENT.REQUEST_ACCEPTED })
    return axios
        .get(`/users/${userId}/agreement?type=${agreementType}`)
        .then((response) => {
            const { data } = response
            dispatch({ type: USER_AGREEMENT.RECEIVE_ACCEPTED, data })
            return { userAgreement: data, hasExistingAgreement: true }
        })
        .catch((error) => {
            if (error?.status !== 404) {
                dispatch(handleRequestError(error))
            }
            dispatch({ type: USER_AGREEMENT.ERROR_ACCEPTED })
            return { hasExistingAgreement: false }
        })
}

export const createUserAgreement =
    ({ userAgreementType }) =>
    (dispatch, getState) => {
        const { profile } = getState()
        const { id: userId, accountantId } = profile

        return axios
            .post(`/users/${userId}/useragreements`, { accountantId, type: userAgreementType, userId })
            .then((response) => response.data)
            .catch((error) => {
                dispatch(handleRequestError(error))
                return Promise.reject(error)
            })
    }
